import { Component, computed, inject, viewChild } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenu, MatMenuModule } from '@angular/material/menu';
import { RouterLink, RouterLinkActive } from '@angular/router';

import { SessionStore } from '@app/core/session/session-store';
import { AuthClient } from '@shared/api/identity/clients/auth.client';

const UNKNOWN_IDENTITY = 'Usuário';

@Component({
  selector: 'app-action-user',
  imports: [MatDividerModule, MatIconModule, MatMenuModule, RouterLink, RouterLinkActive],
  templateUrl: './action-user.component.html',
  styleUrls: ['./action-user.component.css'],
})
export class ActionUserComponent {
  private readonly sessionStore = inject(SessionStore);
  private readonly authClient = inject(AuthClient);

  readonly menu = viewChild.required(MatMenu);

  protected readonly identity = computed(() => this.sessionStore.session()?.userEmail || UNKNOWN_IDENTITY);

  constructor() {
    this.signOutWithoutSession();
  }

  protected signOut(): void {
    if (this.sessionStore.isSignedIn()) {
      this.authClient.logout().subscribe({ error: () => undefined });
    }

    this.sessionStore.signOut();
  }

  private signOutWithoutSession(): void {
    if (!this.sessionStore.session()) {
      this.signOut();
    }
  }
}
